var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "items-list--item" },
    [
      _c(
        "b-row",
        { attrs: { "align-v": "center" } },
        [
          _c("b-col", { attrs: { md: _vm.isListTypeCustomer ? 3 : 6 } }, [
            _c("div", { staticClass: "items-list--item-label" }, [
              _vm._v("Job")
            ]),
            _vm._v("\n\t\t\t" + _vm._s(_vm.listItem.jobProfile.info) + "\n\t\t")
          ]),
          _vm._v(" "),
          _vm.isListTypeCustomer
            ? _c("b-col", { attrs: { md: "3" } }, [
                _c("div", { staticClass: "items-list--item-label" }, [
                  _vm._v("Person")
                ]),
                _vm._v(
                  "\n\t\t\t" + _vm._s(_vm.listItem.pseudonym.label) + "\n\t\t"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("b-col", { attrs: { md: "5" } }, [
            _c("div", { staticClass: "items-list--item-label" }, [
              _vm._v("Verabschiedung")
            ]),
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.listItem.initiator.label) +
                " |\n\t\t\t" +
                _vm._s(_vm._f("weekdayShort")(_vm.listItem.creationDate)) +
                ", " +
                _vm._s(_vm._f("date")(_vm.listItem.creationDate)) +
                "\n\t\t"
            )
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "text-right", attrs: { md: "1" } }, [
            _vm.deletable
              ? _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.remove = true
                      }
                    }
                  },
                  [
                    _c("Icon", {
                      attrs: { icon: "bin", size: "1comma5x", color: "primary" }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.remove
        ? _c(
            "ConfirmPopUp",
            {
              attrs: {
                title: "Verabschiedung entfernen",
                "confirm-disabled": _vm.removing,
                "confirm-loading": _vm.removing,
                closable: !_vm.removing
              },
              on: {
                confirm: _vm.removeSendOff,
                hidden: function($event) {
                  _vm.remove = false
                }
              }
            },
            [_vm._v("\n\t\tSoll der Job wirklich wieder angezeigt werden?\n\t")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }